/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyFormResponse = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        categoryId: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        status: {
    type: 'number',
    isRequired: true,
},
        isStandard: {
    type: 'boolean',
    isRequired: true,
},
        questions: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestion',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        updatedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};